import { useTranslation } from "react-i18next";
import { App } from "antd";

import { useExportParticipantsMutation } from "@/redux/service";
import { saveTextFile } from "@/shared/utils/download";
import { EXPORT_MIME_TYPE } from "@/features/certifications/participants/constants";
import { UseParticipantExportOptions } from "@/features/certifications/participants/types";

export const useParticipantExport = ({
  certificationSlug,
  filters,
}: UseParticipantExportOptions) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const [exportParticipants, { isLoading }] = useExportParticipantsMutation();

  const handleExport = async () => {
    try {
      const csv = await exportParticipants(filters).unwrap();
      saveTextFile(
        csv,
        `${certificationSlug}-participants.csv`,
        EXPORT_MIME_TYPE,
      );
    } catch {
      notification.error({
        message: t("certification.admin.participants.exportError"),
      });
    }
  };

  return { handleExport, isExporting: isLoading };
};
